import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
const PREFIX = 'Empty';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    height: '100%',
  },
}));

const Empty = props => {
  const { children } = props;

  return <Root className={classes.root}>{children}</Root>;
};

Empty.propTypes = {
  children: PropTypes.node,
};

export default Empty;
